import { lsGet, lsSave } from '@/utils/localStorageController'
import logout from '@/mixins/logout'

const customerIncompleteTryCountName = 'sc_incomplete_customer_try_count'
const customerIncompleteToastShown = 'sc_incomplete_customer_toast_shown'
export default {
  mixins: [logout],
  methods: {
    handleIncompleteCustomer () {
      const tryCount = lsGet(customerIncompleteTryCountName) || 0
      if (Number(tryCount) < 3) {
        this.$loader.show(' ')
        lsSave(customerIncompleteTryCountName, tryCount + 1)
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      } else {
        if (!lsGet(customerIncompleteToastShown)) {
          this.toast('info', {
            message: 'Molimo uloguj se ponovo'
          })
          lsSave(customerIncompleteToastShown, 'true')
        }
        setTimeout(() => {
          this.logoutUser()
        }, 3000)
      }
    }
  }
}
